import { render, staticRenderFns } from "./ShippingReleaseOrders.vue?vue&type=template&id=6c44ade6"
import script from "./ShippingReleaseOrders.vue?vue&type=script&lang=js"
export * from "./ShippingReleaseOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports